import { useQuery } from 'src/graphql';
import { JOB_STAKEHOLDERS_QUERY } from 'src/graphql/jobStakeholders/query';

export const useJobStakeholders = (jobId, skip = false) =>
  useQuery(JOB_STAKEHOLDERS_QUERY, { variables: { jobId }, skip });
